import { RequireAuth } from '@auth/RequireAuth';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { useThemeStore } from '@store/useThemeStore';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createAppTheme } from '@theme/createAppTheme';
import { useMemo } from 'react';
import { RouterProvider } from 'react-router';

import { router } from './router';

const queryClient = new QueryClient();

export const App = () => {
  const mode = useThemeStore(state => state.mode);
  const theme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <RequireAuth>
          <RouterProvider router={router} />
        </RequireAuth>
      </QueryClientProvider>
    </ThemeProvider>
  );
};
